import { render, staticRenderFns } from "./Contact-web.vue?vue&type=template&id=195d3558&scoped=true"
import script from "./Contact-web.vue?vue&type=script&lang=js"
export * from "./Contact-web.vue?vue&type=script&lang=js"
import style0 from "./Contact-web.vue?vue&type=style&index=0&id=195d3558&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195d3558",
  null
  
)

export default component.exports